import {useTranslation} from '@wix/yoshi-flow-editor';

export type Address = {
  country?: null | string;
  subdivision?: null | string;
  city?: null | string;
  postalCode?: null | string;
  addressLine1?: null | string;
  addressLine2?: null | string;
};

const translationKeysMap = new Map<string, string[]>([
  [
    'thankYouPage.address.addressLine1addressLine2CitySubdivisionPostalCodeCountry',
    ['addressLine1', 'addressLine2', 'city', 'country', 'subdivision', 'postalCode'],
  ],
  [
    'thankYouPage.address.addressLine1addressLine2CitySubdivisionCountry',
    ['addressLine1', 'addressLine2', 'city', 'country', 'subdivision'],
  ],
  [
    'thankYouPage.address.addressLine1addressLine2CityPostalCodeCountry',
    ['addressLine1', 'addressLine2', 'city', 'country', 'postalCode'],
  ],
  ['thankYouPage.address.addressLine1addressLine2CityCountry', ['addressLine1', 'addressLine2', 'city', 'country']],
  [
    'thankYouPage.address.addressLine1CitySubdivisionPostalCodeCountry',
    ['addressLine1', 'city', 'country', 'subdivision', 'postalCode'],
  ],
  ['thankYouPage.address.addressLine1CitySubdivisionCountry', ['addressLine1', 'city', 'country', 'subdivision']],
  ['thankYouPage.address.addressLine1CityPostalCodeCountry', ['addressLine1', 'city', 'country', 'postalCode']],
  ['thankYouPage.address.addressLine1CityCountry', ['addressLine1', 'city', 'country']],
  [
    'thankYouPage.address.addressLine1addressLine2PostalCodeCountry',
    ['addressLine1', 'addressLine2', 'country', 'postalCode'],
  ],
  ['thankYouPage.address.addressLine1addressLine2Country', ['addressLine1', 'addressLine2', 'country']],
  ['thankYouPage.address.addressLine1PostalCodeCountry', ['addressLine1', 'country', 'postalCode']],
  ['thankYouPage.address.subdivisionCountry', ['country', 'subdivision']],
  ['thankYouPage.address.addressLine1Country', ['addressLine1', 'country']],
  ['thankYouPage.address.country', ['country']],
]);

export function useAddressFormatter() {
  const {t} = useTranslation();

  return (availableValues: Address): string | undefined => {
    if (!availableValues?.country) {
      return;
    }

    for (const [translationKey, fields] of translationKeysMap) {
      if (fields.every((name) => !!availableValues[name as keyof Address])) {
        return t(translationKey, availableValues);
      }
    }
  };
}
